import React, { FC, useEffect, ReactNode } from "react";
import Heading from "components/Heading/Heading";
import Glide from "@glidejs/glide";
import ncNanoId from "utils/ncNanoId";
import NextPrev from "shared/NextPrev/NextPrev";
import { DEMO_CAR_LISTINGS } from "data/listings";
import { CarDataType } from "data/types";
import { useSearch } from "hooks/useFetch";
import ItemCard from "components/ItemCard/ItemCard";

// OTHER DEMO WILL PASS PROPS
const DEMO_DATA: CarDataType[] = DEMO_CAR_LISTINGS.filter((_, i) => i < 8);

export interface SectionSliderRecommendationProps {
  className?: string;
  itemClassName?: string;
  stayListings?: CarDataType[];
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  headingIsCenter?: boolean;
  tabs?: string[];
  itemPerRow?: 4 | 5;
  sliderStyle?: "style1" | "style2";
  category?: string;
  current?: string;
}

const SectionSliderRecommendation: FC<SectionSliderRecommendationProps> = ({
  current,
  category = "Transportasi",
  className = "",
  itemClassName = "",
  stayListings = DEMO_DATA,
  heading = "Barang sewa terbaru",
  subHeading = "Barang-barang sewa yang baru ada di Rentrips",
  itemPerRow = 5,
  sliderStyle = "style1",
}) => {
  const [data] = useSearch(`category=${category}`);
  const UNIQUE_CLASS = "glide_" + ncNanoId();

  useEffect(() => {
    if (data.length > 4 && document.querySelector(`.${UNIQUE_CLASS}`)) {
      new Glide(`.${UNIQUE_CLASS}`, {
        perView: itemPerRow,
        gap: 32,
        bound: true,
        breakpoints: {
          1280: {
            perView: itemPerRow,
          },
          1024: {
            gap: 20,
            perView: itemPerRow,
          },
          768: {
            gap: 20,
            perView: itemPerRow - 1,
          },
          640: {
            gap: 20,
            perView: itemPerRow - 2,
          },
          500: {
            gap: 20,
            perView: itemPerRow - 3,
          },
        },
      }).mount();
    }
  }, [data]);

  return (
    <div className={`nc-SectionSliderNewCategories ${className}`}>
      <div className={`${UNIQUE_CLASS}  flow-root`}>
        <Heading
          desc={subHeading}
          hasNextPrev={sliderStyle === "style1"}
          isCenter={sliderStyle === "style2"}
        >
          {heading}
        </Heading>
        {data.length > 4 ? (
          <div>
            <div className="glide__track" data-glide-el="track">
              <div className="glide__slides">
                {data
                  .filter((item) => item._id !== current)
                  .map((item, index) => {
                    return (
                      <ItemCard
                        key={index}
                        className={`glide__slide ${itemClassName}`}
                        data={item}
                      />
                    );
                  })}
              </div>
            </div>
            {sliderStyle === "style2" && (
              <NextPrev className="justify-center mt-16" />
            )}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-5">
            {data
              .filter((item) => item._id !== current)
              .map((item, index) => {
                return <ItemCard key={index} data={item} />;
              })}
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionSliderRecommendation;
